import { useEffect, useRef, useState } from 'react';
import styles from './header.module.scss';
import logo from '../../assets/images/logo.svg';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

export default function Header() {
  const [menu, setMenu] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const header = useRef();
  const location = useLocation();

  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };
  useEffect(() => {
    if (menu) {
      document.body.classList.add('active');
    } else {
      document.body.classList.remove('active');
    }
  }, [menu]);
  useEffect(() => {
    setMenu(false);
    document.body.classList.remove('active');
  }, [location]);
  useEffect(() => {
    function scrollFunc() {
      if (window.scrollY >= 60) {
        setIsSticky(true);
      } else setIsSticky(false);
    }
    window.addEventListener('scroll', function () {
      scrollFunc();
    });
    return () => {
      window.removeEventListener('scroll', function () {
        scrollFunc();
      });
    };
  }, []);
  useEffect(() => {
    const windowScroll = () => {
      const links = document.querySelectorAll('.anchorLinks');
      const sections = document.querySelectorAll('.anchor');
      let index = sections.length;
      // eslint-disable-next-line no-empty
      while (--index && window.scrollY + 100 < sections[index]?.offsetTop) {}
      links.forEach((link) => link.classList.remove('active'));
      links[index]?.classList.add('active');
    };
    windowScroll();
    window.addEventListener('scroll', windowScroll);

    return () => {
      if (window) {
        window.removeEventListener('scroll', windowScroll);
      }
    };
  }, []);
  return (
    <div
      className={classNames(styles['header'], {
        [styles.sticky]: isSticky,
      })}
      ref={header}
    >
      <div className='auto__container'>
        <div className={styles['header__inner']}>
          <div className={styles['header__inner-logo']}>
            <a href='https://shivonai.com'>
              <img src={logo} alt='' />
            </a>
          </div>
          <div className={styles.signInContainer}>
            <Link to='https://shivonai.com/signin' className={styles.signInButton}>
              Sign In
            </Link>
          </div>
          <div
            className={classNames(styles['burger'], {
              [styles.active]: menu,
            })}
            onClick={() => setMenu(!menu)}
          >
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}